import { createContext, useContext, useState } from "react";


const MeasurementContext = createContext({
    type: '',
    setType: () => { }
})

export const useMeasurement = () => useContext(MeasurementContext);

export const MeasurementProvider = ({ children }) => {
    const [type, setType] = useState('metric');

    return (
        <MeasurementContext.Provider value={{ type, setType }} >
            {children}
        </MeasurementContext.Provider>
    );
};